import { Component, input } from '@angular/core';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'generic-form-header-section',
    templateUrl: './generic-form-header-section.component.html',
    styleUrl: './generic-form-header-section.component.scss',
  imports: [TranslatePipe],
})
export class GenericFormHeaderSectionComponent {
  title = input.required<string>();
}
